
<div>
  <collapsible-section
      class="collapse-item"
      id="processFlowMetadataCollapse"
      control-name="processFlowMetadataCollapse"
      :is-open="false"
  >
    <template #section-header>
      {{ handler.header }}
    </template>

    <template #section-contents>
      <field-item
          v-for="datum in metadataSection.metadata"
          :key="datum.label"
          :disabled="handler.isDisabled(datum)"
          @click="select(handler.selectMetadata(datum))"
      >
        <row>
          <prefix>
            <icon :glyph="iconGlyph(datum)"/>
          </prefix>
          <column>
            {{ datum.label }}
          </column>
        </row>
      </field-item>
    </template>
  </collapsible-section>
</div>
